module.exports = __webpack_public_path__ + "static/media/13ITC2.1a320864.jpg";